import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-blockquote',
    templateUrl: './block-blockquote.component.html',
})

export class BlockBlockquoteComponent extends BlockAbstractComponent implements OnInit {

}
